import { PlatformLocation } from '@angular/common'
import { inject, Injectable } from '@angular/core'

import { AuthConfig, HttpInterceptorConfig } from '@auth0/auth0-angular'

import { ENV } from '~env/environment'

import { IAppConfig, IEnvState } from '../models'

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private platformLocation = inject(PlatformLocation)

  private _config: IAppConfig = ENV as any

  get config(): IAppConfig {
    return this._config
  }

  setEnvState(envState: IEnvState): void {
    const apiUrl = envState.API_URL || ''
    const ssrApiUrl = envState.SSR_API_URL || ENV.ssrApiUrl || ''

    const auth = this.getOAuthConfig(
      envState.AUTH0_DOMAIN || '',
      envState.AUTH0_CLIENT_ID || '',
      envState.AUDIENCE || ''
    )
    const httpInterceptor = this.getHttpInterceptorConfig(apiUrl)

    this._config.apiUrl = apiUrl
    this._config.ssrApiUrl = this.config.ssrApiUrl || ssrApiUrl
    this._config.auth = auth
    this._config.httpInterceptor = httpInterceptor
  }

  private getHttpInterceptorConfig(apiUrl: string): HttpInterceptorConfig {
    const httpInterceptor: HttpInterceptorConfig = {
      allowedList: [
        `${apiUrl}/user-info`,
        {
          uri: `${apiUrl}/*`,
          allowAnonymous: true,
        },
      ],
    }

    return httpInterceptor
  }

  private getOAuthConfig(domain: string, clientId: string, audience: string): AuthConfig {
    const { protocol, hostname, port } = this.platformLocation
    const redirectUri = `${protocol}//${hostname}${port && port !== '80' ? ':' + port : ''}`

    const oAuthConfig: AuthConfig = {
      domain,
      clientId,
      cacheLocation: 'localstorage',
      authorizationParams: {
        audience,
        redirectUri,
        redirect_uri: redirectUri,
      },
    }

    return oAuthConfig
  }
}
